export default __webpack_public_path__ + "locales/de/InfoPanel.json?hash=39108583f7ae4a0e03659d045c1c1123";